import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Header } from 'semantic-ui-react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ListViewView = function ListViewView(props) {
  var description = props.description,
    descriptionTitle = props.descriptionTitle,
    footer = props.footer,
    subtitle = props.subtitle,
    title = props.title;
  return /*#__PURE__*/_jsxs(Grid, {
    style: {
      flexDirection: 'column',
      height: '100%',
      margin: 0
    },
    children: [/*#__PURE__*/_jsx(Grid.Row, {
      children: /*#__PURE__*/_jsx(Grid.Column, {
        children: /*#__PURE__*/_jsx(Header, {
          as: "h3",
          children: title
        })
      })
    }), subtitle && /*#__PURE__*/_jsx(Grid.Row, {
      style: {
        padding: 0
      },
      children: /*#__PURE__*/_jsx(Grid.Column, {
        children: /*#__PURE__*/_jsx(Header, {
          as: "h5",
          style: {
            margin: 0
          },
          children: subtitle
        })
      })
    }), description && /*#__PURE__*/_jsx(Grid.Row, {
      style: {
        paddingBottom: 0
      },
      children: /*#__PURE__*/_jsx(Grid.Column, {
        children: /*#__PURE__*/_jsxs(Header, {
          as: "h5",
          children: [descriptionTitle || '', /*#__PURE__*/_jsx(Header.Subheader, {
            children: description
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Grid.Row, {
      style: {
        paddingBottom: 0,
        flex: 1,
        justifyContent: 'space-evenly',
        alignItems: 'flex-end'
      },
      children: footer
    })]
  });
};
ListViewView.handledProps = ["description", "descriptionTitle", "footer", "subtitle", "title"];
ListViewView.propTypes = {
  description: PropTypes.node,
  descriptionTitle: PropTypes.node,
  footer: PropTypes.node,
  subtitle: PropTypes.node,
  title: PropTypes.node
};
ListViewView.defaultProps = {
  description: null,
  descriptionTitle: null,
  footer: null,
  subtitle: null,
  title: null
};
export default ListViewView;